import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';

import {
  FETCH_INSURANCE_PEOPLE_START,
  FETCH_INSURANCE_PEOPLE_SUCCESS,
  FETCH_INSURANCE_PEOPLE_FAILURE,
  FETCH_INSURANCE_LOGS_START,
  FETCH_INSURANCE_LOGS_SUCCESS,
  FETCH_INSURANCE_LOGS_FAILURE,
  SUBMIT_INSURANCE_PEOPLE_START,
  SUBMIT_INSURANCE_PEOPLE_SUCCESS,
  SUBMIT_INSURANCE_PEOPLE_FAILURE,
} from './actions';

const transformInsurancePerson = response => {
  if (!response.user_insurance_information) {
    return { name: `${response.user_first_name} ${response.user_last_name}` };
  }
  return {
    coverage:
      response.user_insurance_information.insurance_information_coverage_type,
    group:
      response.user_insurance_information.insurance_information_group_name
        ?.insurance_group_name,
    lastSubmit:
      response.user_insurance_information.insurance_information_last_submitted,
    id: response.id,
    familySize:
      response.user_insurance_information.insurance_information_family_member
        .length + 1,
    name: `${response.user_first_name} ${response.user_last_name}`,
    account: response.user_account_business_name,
    insuranceInformationMarkedComplete:
      response.user_insurance_information.insurance_information_marked_complete,
    familyMembers: response.user_insurance_information.insurance_information_family_member?.map(
      member => ({
        name: `${member.insurance_family_member_first_name} ${member.insurance_family_member_last_name}`,
        relationship: member.insurance_family_member_relationship,
        gender: member.insurance_family_member_gender,
        dob: member.insurance_family_member_dob,
        id: member.id,
      })
    ),
  };
};
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
const transformInsuranceLog = response => {
  const people = response.insurance_log_submitted_users.map(
    transformInsurancePerson
  );
  return {
    submitDate: response.insurance_log_submitted_date,
    people,
    id: response.insurance_log_gradient_id,
    numberOfPeople: people.reduce((acc, curr) => (acc += curr.familySize), 0),
  };
};
const fetchInsurancePeopleReducer = createApiReducer(
  [
    FETCH_INSURANCE_PEOPLE_START,
    FETCH_INSURANCE_PEOPLE_SUCCESS,
    FETCH_INSURANCE_PEOPLE_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      people: payload.map(transformInsurancePerson),
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

const fetchInsuranceLogsReducer = createApiReducer(
  [
    FETCH_INSURANCE_LOGS_START,
    FETCH_INSURANCE_LOGS_SUCCESS,
    FETCH_INSURANCE_LOGS_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      insuranceLogs: payload.map(transformInsuranceLog),
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

const submitInsurancePeopleReducer = createApiReducer(
  [
    SUBMIT_INSURANCE_PEOPLE_START,
    SUBMIT_INSURANCE_PEOPLE_SUCCESS,
    SUBMIT_INSURANCE_PEOPLE_FAILURE,
  ],
  (payload, state) => {
    const updatedPeople = state.data.people.map(person => {
      const updatedPerson = payload.find(
        newPerson => newPerson.id === person.id
      );
      if (updatedPerson) {
        return transformInsurancePerson(updatedPerson);
      }
      return person;
    });
    return {
      ...state.data,
      people: updatedPeople,
    };
  },
  error => _.get(error, 'payload.response.detail', 'unknown error')
);

const insurancePeople = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchInsurancePeopleReducer,
  submitInsurancePeopleReducer
);

const insuranceLogs = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchInsuranceLogsReducer
);

export const reducer = combineReducers({
  insurancePeople,
  insuranceLogs,
});
